import React from 'react'

interface InboundLayoutProps {
  children?: React.ReactNode
}
const InboundLayout: React.FC<InboundLayoutProps> = ({ children }) => {

  return (
    <>
      {children}
    </>
  )
}

export default InboundLayout
